import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Input.css';

const propTypes = {
    className: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    design: PropTypes.oneOf(['default', 'darker']),
    type: PropTypes.string,
};

export class Input extends React.Component {
    static defaultProps = {
        className: undefined,
        design: 'default',
        type: 'text',
    };

    constructor(props) {
        super(props);

        this.state = {
            isFocused: false,
        };
    }

    refInputField = createRef();

    render() {
        const { className, placeholder, value, type, design, ...inputProps } = this.props;
        const trimmedValue = value.trim();

        return (
            <label
                className={classNames(
                    s.fieldset,
                    {
                        [s.labelOnTop]: trimmedValue.length > 0 || this.state.isFocused,
                        [s.darker]: design === 'darker',
                    },
                    className
                )}
            >
                <p>{placeholder}</p>
                <input
                    {...inputProps}
                    ref={this.refInputField}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    type={type}
                    value={value}
                />
            </label>
        );
    }

    focusOnField = () => {
        if (this.refInputField && this.refInputField.current) {
            this.refInputField.current.focus();
        }
    };

    handleFocus = e => {
        this.setState({
            isFocused: true,
        });

        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
    };

    handleBlur = e => {
        this.setState({
            isFocused: false,
        });

        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    };
}

Input.propTypes = propTypes;



// WEBPACK FOOTER //
// ./app/web/src/components/fields/Input.jsx